import { getUserRole } from "./utils/authUtils";
const navigationItems = [
  {
    role: "Admin",
    component: "CNavItem",
    name: "User Master",
    to: "/admin/user",
    icon: "cilUser",
  },
  {
    role: "Admin",
    component: "CNavItem",
    name: "Role Master",
    to: "/admin/role",
    icon: "cilSpreadsheet",
  },
  {
    role: "Admin",
    component: "CNavItem",
    name: "Brand Master",
    to: "/admin/brand",
    icon: "cilBadge",
  },
  {
    role: "Admin",
    component: "CNavItem",
    name: "Net Weight Master",
    to: "/admin/net",
    icon: "cilBalanceScale",
  },
  {
    role: "Admin",
    component: "CNavItem",
    name: "Outlet Master",
    to: "/user/outletMaster",
    icon: "cilBuilding",
  },

  // {
  //   role: "Admin",
  //   component: "CNavItem",
  //   name: "SKU Type Master",
  //   to: "/admin/sku",
  //   icon: "cilVector",
  // },
  // {
  //   role: "Admin",
  //   component: "CNavItem",
  //   name: "Retailer Reports",
  //   to: "/admin/reports",
  //   icon: "cilList",
  // },
  // {
  //   role: "Admin",
  //   component: "CNavItem",
  //   name: "PKD Reports",
  //   to: "/admin/pkdreports",
  //   icon: "cilList",
  // },
  // {
  //   role: "Admin",
  //   component: "CNavItem",
  //   name: "Wholesaler Reports",
  //   to: "/admin/wholesaler-reports",
  //   icon: "cilList",
  // },
  //   {
  //     role: "Admin",
  //     component: "CNavItem",
  //     name: "Daily Pkd Report",
  //     to: "/admin/dailyreports",
  //     icon: "cilList",
  //   },
  {
    role: "Regularuser",
    component: "CNavItem",
    name: "Market Visit Form List",
    to: "/user/new-dashboard",
    icon: "cilSpeedometer",
  },
  //  {
  //     role: "Regularuser",
  //     component: "CNavItem",
  //     name: "Add Market Visit Data",
  //     to: "/user/market-visit-form",
  //     icon: "cilCode",
  //   },
  {
    role: "Regularuser",
    component: "CNavItem",
    name: "Add Retailer Data",
    to: "/user/web-form",
    icon: "cilCode",
  },
  {
    role: "Regularuser",
    component: "CNavItem",
    name: "Filled Forms List",
    to: "/user/dashboard",
    icon: "cilCode",
  },

  {
    role: "Regularuser",
    component: "CNavItem",
    name: "Add Wholesaler Data",
    to: "/user/wholesaler-web-form",
    icon: "cilCode",
  },

  {
    role: "Regularuser",
    component: "CNavItem",
    name: "Add PKD Data",
    to: "/user/Pkd-web-form",
    icon: "cilCode",
  },
  {
    role: "Admin",
    component: "CNavItem",
    name: "Attendence Report",
    to: "/user/attendenceReport",
    icon: "cilClock",
  },

  {
    role: "Admin",
    component: "CNavItem",
    name: "Market Visibility Reports",
    to: "/admin/MarketVisibilityReport",
    icon: "cilChartLine",
  },

  {
    role: "Admin",
    component: "CNavItem",
    name: "Market Activity Reports",
    to: "/admin/MarketActivityReport",
    icon: "cilListRich",
  },
  {
    role: "Admin",
    component: "CNavItem",
    name: "Proximity Report",
    to: "/user/proximityReport",
    icon: "cilLocationPin",
  },
  {
    role: "Admin",
    component: "CNavItem",
    name: "Automailer",
    to: "/admin/automailer",
    icon: "cilEnvelopeLetter",
  },
  {
    role: "Admin",
    component: "CNavItem",
    name: "Settings",
    to: "/admin/settings",
    icon: "cilSettings",
  },
];

const getFilteredNavigationItems = () => {
  return navigationItems.filter((item) => item.role === getUserRole());
};

export default getFilteredNavigationItems;
